/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fac_Plan_TitleInputs */

const en_fac_plan_title = /** @type {(inputs: Fac_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facilitator`)
};

const id_fac_plan_title = /** @type {(inputs: Fac_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fasilitator`)
};

/**
* | output |
* | --- |
* | "Facilitator" |
*
* @param {Fac_Plan_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fac_plan_title = /** @type {((inputs?: Fac_Plan_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fac_Plan_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fac_plan_title(inputs)
	return en_fac_plan_title(inputs)
});